import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Table from '../../../../components/Table/Table'
import {
    formatPlannedMaintenance,
    plannedMaintenanceCols,
} from '../../../../helpers/tableUtils'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import { initialPMFilters } from '../../../../helpers/plannedMaintenanceFilters'

const PlannedMaintenance = ({
    requests = [],
    loadPlannedMaintenance,
    assetInfo,
}) => {
    const [allRequests, setRequests] = useState(requests)
    const [filteredRequests, setFilteredRequests] = useState([])
    const [filterOpen, setFilterOpen] = useState(false)
    const [initialFilters, setInitialFilters] = useState(initialPMFilters)
    const [hasActiveFilters, setHasActiveFilters] = useState(false)

    useEffect(() => {
        if (allRequests?.length > 0) {
            setInitialFilters(initialPMFilters)
        }
    }, [allRequests])

    useEffect(() => {
        if (
            loadPlannedMaintenance &&
            requests?.length === 0 &&
            assetInfo?.salesforceID != null
        ) {
            loadPlannedMaintenance()
        }
    }, [assetInfo])

    useEffect(() => {
        setRequests(requests)
        setFilteredRequests(formatPlannedMaintenance(requests))
        if (requests?.length > 0) {
            setInitialFilters(initialPMFilters)
        }
    }, [requests])

    const onFilter = filters => {
        var resultList = [...allRequests]
        var hasOneChecked = false
        filters?.forEach(filterG => {
            var matchesResults = []
            var thisFiltersHasResults = false
            filterG?.filters?.forEach(filter => {
                if (filter?.checked) {
                    thisFiltersHasResults = true
                    hasOneChecked = true
                    matchesResults = [
                        ...matchesResults,
                        ...allRequests?.filter(
                            r => r[filterG?.field] === filter?.filterName,
                        ),
                    ]
                }
            })
            if (thisFiltersHasResults) {
                resultList = [...matchesResults]
            } else [(resultList = [...resultList])]
        })

        if (hasOneChecked) {
            setHasActiveFilters(true)
            setFilteredRequests(formatPlannedMaintenance(resultList))
        } else {
            setHasActiveFilters(false)
            setFilteredRequests(formatPlannedMaintenance(allRequests))
        }
    }

    const renderTable = useCallback(() => {
        return (
            <Table
                selectable={false}
                hasSearch={true}
                columns={plannedMaintenanceCols}
                data={filteredRequests}
                totalResults={requests?.length}
                type="scroll"
                headerTitle="Planned Maintenance Details"
                searchPlaceholder="Search Maintenance"
                actions={[
                    <FilterModal
                        key="filterModal"
                        filtersGroup={initialFilters}
                        open={filterOpen}
                        setOpen={setFilterOpen}
                        onFilter={onFilter}
                        isSmallScreen
                        data={filteredRequests}
                    />,
                ]}
                searchFields={['name', 'status', 'prettyDate']}
                hasActiveFilters={hasActiveFilters}
            />
        )
    }, [allRequests, filterOpen, filteredRequests, initialFilters])

    return renderTable()
}

PlannedMaintenance.propTypes = {
    requests: PropTypes.array,
    loadPlannedMaintenance: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.any,
    ]),
    assetInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
}

export default PlannedMaintenance
